import { useMemo, useState } from 'react';
import {
  formatDate,
  OutputSnapshotVersionType,
  useOutputValueDateQuery,
} from '@atlas-frontend/sdk';

export function useOutputValueDates(
  outputDescriptionId?: number,
  descriptionId?: string,
  valueDate?: string,
) {
  const [outputValueDate, setOutputValueDate] =
    useState<OutputSnapshotVersionType['outputDate']>();
  const { isLoading, data } = useOutputValueDateQuery(
    {
      outputDescriptionId: outputDescriptionId ?? 0,
      descriptionId: descriptionId ?? '',
      valueDate: valueDate ?? '',
    },
    {
      enabled: !!(outputDescriptionId && descriptionId && valueDate),
    },
  );
  const options = useMemo(() => {
    const outputOptions =
      data?.map((outputDate) => ({
        value: outputDate.resultDoId,
        label: formatDate(outputDate.resultDoValueDate) as string,
        outputDate,
      })) ?? [];
    if (outputOptions.length === 1) {
      setOutputValueDate(outputOptions[0].outputDate);
    } else {
      setOutputValueDate(undefined);
    }

    return outputOptions;
  }, [data]);

  return { data, isLoading, options, outputValueDate, setOutputValueDate };
}
